import { Injectable, Inject, EventEmitter, SkipSelf } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { WishList, Product, EnvironmentModel, Cart, Child, AddressModel, CommonLibService } from '@sass-library/common-lib';
import { BehaviorSubject, forkJoin, merge, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductLibService {
  private dataAndAttribute: EventEmitter<any> = new EventEmitter();
  private searchProductAttribute: EventEmitter<any> = new EventEmitter();
  private catData: any;
  private searchData: any;
  private selectedCategoryEnable: any;
  public trigger_filter = new Subject();
  public trigger_grid = new Subject();
  public trigger_category = new Subject();
  public trigger_search = new Subject();
  public trigger_tagProductCount = new BehaviorSubject({});
  constructor(private httpClient: HttpClient, @Inject('environment') private env: EnvironmentModel, 
              private commonService: CommonLibService) { }

  public recentProductTransmitter = new Subject<any>()
  recentProduct = this.recentProductTransmitter.asObservable();
  public alsoLikeProductTransmitter = new Subject();
  public dynamicTransmitter = new Subject<any>();
   getRecent(recent) {
     this.recentProductTransmitter.next(recent);
   }
   setRecent(recent): void {
     this.recentProductTransmitter.next(recent);
   }
   getSub() {
     return this.recentProductTransmitter.asObservable();
   }
  getCategoryDataHold() {
    return {
      filterCommonMenu: this.catData, enableSelectedCategory: this.selectedCategoryEnable
    }
  }
  getSearchProductDataHold() {
    return {
      searchData: this.searchData
    }
  }
  setCategoryDataHold(catData, selectedCategory) {
    this.catData = catData;
    this.selectedCategoryEnable = selectedCategory;
    this.dynamicTransmitter.next(this.catData);
    this.dataAndAttribute.emit({filterCommonMenu: this.catData, enableSelectedCategory: this.selectedCategoryEnable})
  }
  setSearchProductHold(data) {
    this.searchData = data;
    this.trigger_search.next(data);
  }
   retrieveSingleCategory(id: string): Observable<any> {
    const url: string = `${this.env.productServiceUrl}` + 'getcategoryforlandingpage/' + `${id}`;

    return this.httpClient.get<any>(url);
  }

  getCartBanner(): Observable<any> {
    const shoppingUrl = 'getcartbannerforui';
    const url: string = `${this.env.contentServiceUrl}` + shoppingUrl;
    return this.httpClient.get<any>(url);
  }

  
  createRazorPayInstance(arg): Observable<any> {
    const shoppingUrl = 'createrazorpayinstance';
    const url: string = `${this.env.commerceOrderServiceUrl}` + shoppingUrl;
    return this.httpClient.put<any>(url, arg);
  }
  retrieveSuperCategoryWithFilter(id: string) {
    const url: string = `${this.env.productServiceUrl}` + 'getsupercategoryandfilter/' + `${id}`;
    return this.httpClient.get(url)
  }
  retrieveMainCategoryWithFilter(id: string) {
    const url: string = `${this.env.productServiceUrl}` + 'getMaincategoryAndFilter/' + `${id}`;
    return this.httpClient.get(url)
  }
  retrieveSubCategoryWithFilter(id: string) {
    const url: string = `${this.env.productServiceUrl}` + 'getsubcategoryandfilter/' + `${id}`;
    return this.httpClient.get(url)
  }
   getNavbarCategory(): Observable<any> {
     const url = `${this.env.productServiceUrl}` +  'viewcategorywithattribute';
     return this.httpClient.get<any>(url);
   }
   getAllSuperCategoryAttributeFilter(data): Observable<any> {
    const url: string = `${this.env.productServiceUrl}` + 'supattributeproduct';
    return this.httpClient.post<any>(url, data);
  }
  getAllSuperCategoryFilter(data): Observable<any> {
    const url: string = `${this.env.productServiceUrl}` + 'supercatfilter';
    return this.httpClient.post<any>(url, data);
 }
 getAllSubCategoryFilter(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'subcatfilter';
  return this.httpClient.post<any>(url, data);
}
 getAllMainCategoryFilter(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'maincatfilter';
  return this.httpClient.post<any>(url, data);
}
getWishList(wish): Observable<WishList[]> {
  const url: string = `${this.env.productServiceUrl}` + 'getwishlistmvp/' + `${wish.userId}`;
  return this.httpClient.get<WishList[]>(url);
}
addToWishList(wish): Observable<WishList[]> {
  const url: string = `${this.env.productServiceUrl}` + 'wishlistmvp/' + `${wish.userId}`;
  return this.httpClient.put<WishList[]>(url, wish);
}
getIncrementRate(): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getincrementrate';
  return this.httpClient.get<any>(url);
}

getAllSuperCategoryProduct(superid, data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'allsupercategory/' + superid;
  return this.httpClient.put<Product>(url, data);
}
getAllMainCategoryProducts(mainid, data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'allmaincategory/' + mainid;
  return this.httpClient.put<Product>(url, data);
}
getAllSubCategoryProducts(subid, data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'allsubcategory/' + subid;
  return this.httpClient.put<Product>(url, data);
}
getAllProductByUrl(cat, data): Observable<any> {
  let httpParams = new HttpParams()
  .set('catid', cat.catid)
  if (cat.mainid != null) {
    httpParams = httpParams.set('mainid', cat.mainid);
}
if (cat.subid != null) {
  httpParams = httpParams.set('subid', cat.subid);
}
  const url: string = `${this.env.productServiceUrl}` +  'retrieveallproductbyurl';
  return this.httpClient.post<Product>(url, data, {params: httpParams});
}
getSearchProductSuperCategoryAttribute(data, id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'filterforsearchproductsupercategoryattribute/' + id;
  return this.httpClient.put<any>(url, data);
}
getSearchProductMainCategoryAttribute(data, id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'filterforsearchproductmaincategoryattribute/' + id;
  return this.httpClient.put<any>(url, data);
}
getSearchProductSubCategoryAttribute(data, id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'filterforsearchproductsubcategoryattirbute/' + id;
  return this.httpClient.put<any>(url, data);
}
getCategoryForProductSearch(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getcategoryforproductsearch';
  return this.httpClient.post<any>(url, data);
}
getSubCategorySearchProduct(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'gtesearchproductbysubcategoryattribute';
  return this.httpClient.post<any>(url, data);
}
getMainCategorySearchProduct(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'gtesearchproductbymaincategoryattribute';
  return this.httpClient.post<any>(url, data);
}
getSuperCategorySearchProduct(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getsearchproductbysupercategoryattribute';
  return this.httpClient.post<any>(url, data);
}
getAllCategoryForLandingPage(): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getallcategoryforlandingpage';
  return this.httpClient.get<any>(url);
}
searchProduct(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'searchproduct';
  return this.httpClient.post<any>(url,data);
}
getNewArrivalCategory(): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getcategoryfornewarrival';
  return this.httpClient.get<any>(url);
}
getNewArrivalProductBySubCategory(data, id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getnewarrivalproductforsubcategroy/' + id;
  return this.httpClient.post<any>(url, data);
}
getNewArrivalProductBySuperCategory(data, id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getnewarrivalproductforsupercategroy/' + id;
  return this.httpClient.post<any>(url, data);
}
getNewArrivalProductByMainCategory(data, id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getnewarrivalproductformaincategroy/' + id;
  return this.httpClient.post<any>(url, data);
}
getNewArrival(): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getnewarrival';
  return this.httpClient.get<any>(url);
}
getSelectedCategory(id: string): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getsinglecategory/' + id;
  return this.httpClient.get<any>(url);
}
getAllBodyHeight() {
  const url: string = `${this.env.productServiceUrl}` +  'getallbodyheight';
  return this.httpClient.get<any>(url);
}
getHowToMeasure() {
  const url: string = `${this.env.productServiceUrl}` +  'gethowtomeasure';
  return this.httpClient.get<any>(url);
}
getSizeGuideBySubCategoryWithVendor(id: string, vendorID: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getsizeguidebysubcategoryandvendor/' + id + '/' + vendorID;
  return this.httpClient.get<any>(url);
}
getSizeGuideByMainCategoryWithVendor(id: string, vendorID: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getsizeguidebymaincategoryandvendor/' + id + '/' + vendorID;
  return this.httpClient.get<any>(url);
}
getSizeGuideBySuperCategoryWithVendor(id: string, vendorID: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getsizeguidebysupercategoryandvendor/' + id + '/' + vendorID;
  return this.httpClient.get<any>(url);
}
getSizeGuideBySuperCategory(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getsizeguidebysupercategory/' + id;
  return this.httpClient.get<any>(url);
}
getSizeGuideByMainCategory(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getsizeguidebymaincategory/' + id;
  return this.httpClient.get<any>(url);
}
getSizeGuideBySubCategory(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getsizeguidebysubcategory/' + id;
  return this.httpClient.get<any>(url);
}
getBlouseMeasurementBySuperCategory(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getselectedsupercategorymeasurement/' + id;
  return this.httpClient.get<any>(url);
}
getKameezMeasurementBySuperCategory(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getselectedsupercategorykameezmeasurement/' + id;
  return this.httpClient.get<any>(url);
}
getLehengaMeasurementBySuperCategory(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getlehengabycategory/' + id;
  return this.httpClient.get<any>(url);
}
addToCart(cart) {
  const url: string = `${this.env.productServiceUrl}` +  'addproducttocart';
  return this.httpClient.post<Cart>(url, cart);
}
shoppingUser(userId: string) {
  const url: string = `${this.env.productServiceUrl}` +  'findcart/' + userId;
  return this.httpClient.get<Cart>(url);
}
getSingleProductReview(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getselectedproductreview/' + id;
  return this.httpClient.get<any>(url);
}
addRecentProductID(recentProduct) {
  const url: string = `${this.env.productServiceUrl}` +  'addrecentproduct';
  return this.httpClient.post<any>(url, recentProduct);
}
getRecentProductID(userId: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getrecentproduct/' + userId;
  return this.httpClient.get<any>(url);
}
getRecentProductByLocalStorage(recentProduct) {
  const url: string = `${this.env.productServiceUrl}` +  'getproductforlocalrecent';
  return this.httpClient.post<any>(url, recentProduct);
}
viewRecentProduct(userId: string) {
  const url: string = `${this.env.productServiceUrl}` +  'getrecentproductbyuser/' + userId;
  return this.httpClient.get<any>(url);
}
getAlsoLike(content) {
  const url: string = `${this.env.productServiceUrl}` +  'getyoumayalsolike';
  return this.httpClient.post<any>(url, content);
}
getCatNote() {
  const url: string = `${this.env.productServiceUrl}` +  'getnote';
  return this.httpClient.get<any>(url);
}
getSingleProductsWithBrand(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'singleproductwithbrand/' + id;
  return this.httpClient.get<Product>(url);
}
getSinglePublishedProducts(id: string) {
  const url: string = `${this.env.productServiceUrl}` +  'singlepublishedproduct/' + id;
  return this.httpClient.get<Product>(url);
}
addToCartDecrement(cart): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'findcartproduct';
  return this.httpClient.post<any>(url, cart);
}
deleteToCart(userid, proId) {
  const url: string = `${this.env.productServiceUrl}` + 'deletecart/' + userid + '/itemId/' + proId;
  return this.httpClient.delete<any>(url);
}
cartCount(userId): Observable<any> {
  const url: string =`${this.env.productServiceUrl}` +  'findcartcount/' + userId;
  return this.httpClient.get<any>(url);
}
moveWishlist(wish): Observable<any> {
  const url: string =`${this.env.productServiceUrl}` +  'movetowishlistmvp/' + wish.userId;
  return this.httpClient.put<any>(url, wish);
}
getAllSizeWiseIncrement(): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` +  'getallsizewiseincrement';
  return this.httpClient.get<any>(url);
}
deleteAllCart(carId) {
  const url: string = `${this.env.productServiceUrl}` + 'deletecart/' + carId;
  return this.httpClient.delete<any>(url);
}
updateQtyByShipping(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}`+ 'updateinventorybyshipping';
  return this.httpClient.post<any>(url, data);
}
unpublishWithoutQty(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'unpublishquantity';
  return this.httpClient.post<any>(url, data);
}
retrieveProductWithChild(parentId, childId) {
  const url: string = `${this.env.productServiceUrl}` + 'retrieveproductwithchil/' + parentId + '/' + childId;
  return this.httpClient.get<any>(url);
}
getGeneralSettings(): Observable<any> {
  const dataUrl = 'findgeneralsetting';
  const url: string =  `${this.env.commerceOrderServiceUrl}` + dataUrl;
  return this.httpClient.get<any>(url);
}
retrivePinCodeApi(pincode) {
  const url: string = `${'https://api.postalpincode.in/pincode/'}` + pincode;
  return this.httpClient.get<any>(url);
}
findSelecredCategoryGst(data) {
  const url: string = `${this.env.productServiceUrl}` + 'findselectedcategorygst';
  return this.httpClient.post<any>(url, data);
}
cartIncrement(customerId, cartId): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'cartincrement/' + customerId  + '/' + cartId;
  return this.httpClient.get<any>(url);
} 
cartDecrement(customerId, cartId): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'cartdecrement/' + customerId  + '/' + cartId;
  return this.httpClient.get<any>(url);
} 
updateCartQuantity(customerId, cartId, data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'updatecartquantity/' + customerId  + '/' + cartId;
  return this.httpClient.put<any>(url, data);
} 
getStringingByCategoryId(id: string): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getaddstringingbycategoryid/' + id;
  return this.httpClient.get<any>(url);
} 
getCategoryProducts(id, count, perPage){
  var seq = [];
   var totalCount = (count / perPage) < 1 ? 1 : count / perPage;
  for (let i = 0; i <= totalCount - 1; i++) {
    const httpParams = new HttpParams().set('id', id).set('pageNo', i.toString()).set('perPage', perPage);
  const url:string = `${this.env.productServiceUrl}` + 'getstringingproduct';
  seq.push(this.httpClient.get<any>(url, {params: httpParams}))
  }
  return forkJoin(seq);
}
getProductWithBrand(id):Observable<any>{
  const url:string = `${this.env.productServiceUrl}` + 'retrieveproductwithbrand/' + id;
  return this.httpClient.get<Product>(url);
}
getGiftWrapSetting(): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'getgiftwrappingsettingforui';
  return this.httpClient.get<any>(url);
}
getCartWithTool(userId: string): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'getcartwithtool/' + userId;
  return this.httpClient.get<any>(url);
}
getCategoryForBrand(brandId: string): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'getcategoryforbrand/' + brandId;
  return this.httpClient.get<any>(url);
}
getBrandImage(): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'getcategoryforbrandwithbrandimage';
  return this.httpClient.get<any>(url);
}

addwishlistforproductlist(wishlist): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'addwishlistforproductlist';
  return this.httpClient.post<any>(url, wishlist);
}
getwishlistproductid(wishlist): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'getwishlistproductid';
  return this.httpClient.post<any>(url, wishlist);
}
addwishlistforcart(wishlist): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'addwishlistforcart';
  return this.httpClient.post<any>(url, wishlist);
}
removewishlistproductid(wishlist): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'removewishlistproductid';
  return this.httpClient.post<any>(url, wishlist);
}
getwishlistwithproduct(wishlist): Observable<any> {                                
  const url: string = `${this.env.productServiceUrl}` + 'getwishlistwithproduct';
  return this.httpClient.post<any>(url, wishlist);
}
getSeoAttribute(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'retrieveproductwithseoattribute/' + id;
  return this.httpClient.get<Product>(url);
}
getSeoCategory(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'findseocategory/' + id;
  return this.httpClient.get<Product>(url);
}
getSubCategoryProductAttribute(id, data) {
  const url: string = `${this.env.productServiceUrl}` + 'getsubcategoryfilterattribute/' + id;
  return this.httpClient.post<Product>(url, data).toPromise();
}
getMainCategoryProductAttribute(id, data) {
  const url: string = `${this.env.productServiceUrl}` + 'getmaincategoryfilterattribute/' + id;
  return this.httpClient.post<Product>(url, data).toPromise();
}
getSuperCategoryProductAttribute(id, data) {
  const url: string = `${this.env.productServiceUrl}` + 'getsupercategoryfilterattribute/' + id;
  return this.httpClient.post<Product>(url, data).toPromise();
}
getAllProductAttributeByUrl(cat, data) {
  let httpParams = new HttpParams()
  .set('catid', cat.catid)
  if (cat.mainid != null) {
    httpParams = httpParams.set('mainid', cat.mainid);
}
if (cat.subid != null) {
  httpParams = httpParams.set('subid', cat.subid);
}
  const url: string = `${this.env.productServiceUrl}` +  'urlproductattributebyfilter';
  return this.httpClient.post<Product>(url, data, {params: httpParams}).toPromise();
}
getSearchProductAttribute(data) {
  const url: string = `${this.env.productServiceUrl}` +  'searchproductattribute';
  return this.httpClient.post<Product>(url, data).toPromise();
}
getSearchProductByFilterAttribute(data) {
  const url: string = `${this.env.productServiceUrl}` +  'searchproductbyfilterattribute';
  return this.httpClient.post<Product>(url, data);
}

getCategoryByUrl(cat):Observable<any> {
  let httpParams = new HttpParams()
  .set('catid', cat.catid)
  if (cat.mainid != null) {
    httpParams = httpParams.set('mainid', cat.mainid);
}
if (cat.subid != null) {
  httpParams = httpParams.set('subid', cat.subid);
}
  const url: string = `${this.env.productServiceUrl}` +  'retrievecategorybyurl';
  return this.httpClient.get<Product>(url, {params: httpParams});
}
getCategoryForLandingByUrl(urlLink):Observable<any> {
  let httpParams = new HttpParams()
    httpParams = httpParams.set('url', urlLink);
  const url: string = `${this.env.productServiceUrl}` +  'getcategoryforlandingpagebyurl';
  return this.httpClient.get<Product>(url, {params: httpParams});
}
getSubCategoryForHeader(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsubcategoryforheader/' + id;
  return this.httpClient.get<Product>(url);
}
getMainCategoryForHeader(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getmaincategoryforheader/' + id;
  return this.httpClient.get<Product>(url);
}
getSuperCategoryForHeader(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsupercategoryforheader/' + id;
  return this.httpClient.get<Product>(url);
}
getAllFilterOption(): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'findfilteroptions';
  return this.httpClient.get<Product>(url);
}
retrieveAllFilterOption() {
  const url: string = `${this.env.productServiceUrl}` + 'findfilteroptions';
  return this.httpClient.get<any>(url).toPromise();
}
getSubProductCount(id, condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsubcategoryproductcount/' + id;
  return this.httpClient.post<any>(url, condition);
}
getMainProductCount(id, condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getmaincategoryproductcount/' + id;
  return this.httpClient.post<any>(url, condition);
}
getSuperProductCount(id, condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsupercategoryproductcount/' + id;
  return this.httpClient.post<any>(url, condition);
}
getUrlProductCount(cat, condition): Observable<any> {
  let httpParams = new HttpParams()
  .set('catid', cat.catid)
  if (cat.mainid != null) {
    httpParams = httpParams.set('mainid', cat.mainid);
}
if (cat.subid != null) {
  httpParams = httpParams.set('subid', cat.subid);
}
  const url: string = `${this.env.productServiceUrl}` + 'urlproductcountwithprice';
  return this.httpClient.post<any>(url, condition, {params: httpParams});
}
getSearchProductCount(condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'searchproductcount';
  return this.httpClient.post<any>(url, condition);
}
checkGiftCardAvailabilityForBrand(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'checkgiftwrappingavailablebasedonbrand/' + id;
  return this.httpClient.get<any>(url);
}
getSingleBrand(id): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsinglebranddetails/' + id;
  return this.httpClient.get<any>(url);
}
checkComboOfferAvailability(id): Observable<any> {
  const url: string = `${this.env.marketingServiceUrl}` + 'checkcomboofferavailability/' + id;
  return this.httpClient.get<any>(url);
}
getProductByBrandWithCategory(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'retrieveproudctbybrandwithcategory';
  return this.httpClient.post<any>(url, data);
}
getProductbyBrandPage(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'retrieveproductbybrandpage';
  return this.httpClient.post<any>(url, data);
}

connectFilter(attributes) {
  const collection = new Array() as any;
  for (let attribu of attributes) {
    for (let single of attribu) {
      if (collection.length !== 0 && collection.some(collect => collect._id === single._id)) {
        const selectedField = collection.find(collect => collect._id === single._id);
        single.fieldValue.forEach(field => {
          if (!selectedField.fieldValue.some(selField => selField._id === field._id)) {
            selectedField.fieldValue.merge(field);
          }
        })
      } else {
        collection.push(single);
      }
    }
  }
    return collection;
}
connectFilterByName(attributes) {
  const collection = new Array() as any;
  for (let attribu of attributes) {
    for (let single of attribu) {
      if (collection.length !== 0 && collection.some(collect => collect.fieldName.toLowerCase() === single.fieldName.toLowerCase())) {
        const selectedField = collection.find(collect => collect.fieldName.toLowerCase() === single.fieldName.toLowerCase());
        single.fieldValue.forEach(field => {
          if (!selectedField.fieldValue.some(selField => selField.fieldAttributeValue.trim().toLowerCase() === field.fieldAttributeValue.trim().toLowerCase())) {
            selectedField.fieldValue.push(field);
          }
        })
      } else {
        collection.push(single);
      }
    }
  }
    return collection;
}
getSelectedGst(gstId): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getselectedgstconfiguration';
  return this.httpClient.post<any>(url, gstId);
} 
getEnhancementPageForUI(proId: string, tempId: string): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getenhancementpageforui/' + proId + '/' + tempId;
  return this.httpClient.get<any>(url);
} 
getCustomOfferForDetailPage(proId: string): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getcustomofferfordetailpage/' + proId;
  return this.httpClient.get<any>(url);
} 
getCustomOfferOrderIDForOrder(data): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getcustomofferorderidfororder';
  return this.httpClient.post<any>(url, data);
} 

getProductWithChild(id, childId): Observable<any> {
  const categoryUrl = 'retrieveproductwithchild/' + id +'/' + childId;
  const url: string = `${this.env.productServiceUrl}` + categoryUrl;
  return this.httpClient.get<Product>(url);
}

getTagProductCount(id, data): Observable<any> {
  const httpParams = new HttpParams()
  .set('tagId', id);
  const url: string = `${this.env.productServiceUrl}` + 'getproductcountbytag';
  return this.httpClient.post<Product>(url, data, {params: httpParams});
}
getTagProductFilter(id, data) {
  const httpParams = new HttpParams()
  .set('tagId', id);
  const url: string = `${this.env.productServiceUrl}` + 'getfilerattributebytag';
  return this.httpClient.post<Product>(url, data, {params: httpParams}).toPromise();
}
getTagProductList(id, data): Observable<any> {
  const httpParams = new HttpParams()
  .set('tagId', id);
  const url: string = `${this.env.productServiceUrl}` + 'getproductlistbytag';
  return this.httpClient.post<Product>(url, data, {params: httpParams});
}
getRazorpayPaymentSetting(): Observable<any> {
  const categoryUrl = 'getallrazorpaymentsettingforui';
  const url: string = `${this.env.commerceOrderServiceUrl}` + categoryUrl;
  return this.httpClient.get<Product>(url);
}
getStringingProductCount(id): Observable<any> {
  const httpParams = new HttpParams().set('id', id);
  const categoryUrl = 'getstringproductcount';
  const url: string = `${this.env.productServiceUrl}` + categoryUrl;
  return this.httpClient.get<Product>(url, {params: httpParams});
}
getBrandForUI(id): Observable<any> {
  const httpParams = new HttpParams().set('id', id);
  const categoryUrl = 'getbrandforui';
  const url: string = `${this.env.productServiceUrl}` + categoryUrl;
  return this.httpClient.get<Product>(url, {params: httpParams});
}
/* ------------- other module service call start ------------ */
getSelctedMeasurementByUser(id) {
  const url: string = `${this.env.customerServiceUrl}` +  'getselectedmeasurement/' + id;
  return this.httpClient.get<any>(url);
}
createInvoice(data): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'createinvoice';
  return this.httpClient.post<any>(url, data);
}
saveInquiry(inquiry){
  const url: string = `${this.env.customerServiceUrl}` +  'inquiry';
  return this.httpClient.post<any>(url, inquiry);
}
getComboOffer(): Observable<any> {
  const url: string = `${this.env.marketingServiceUrl}` +  'retrievediscountforui';
  return this.httpClient.get<any>(url);
}
getWalletConditionforCart(): Observable<any> {
  const url: string = `${this.env.marketingServiceUrl}` +  'getwalletconditionforcart';
  return this.httpClient.get<any>(url);
}
getCustomerWallet(id: string): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` +  'getcustomerwallet/' + id;
  return this.httpClient.get<any>(url);
}
getShippingFees(): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'getshippingfees';
  return this.httpClient.get<any>(url);
}
getFlexibleCouponForCart(): Observable<any> {
  const url: string = `${this.env.marketingServiceUrl}` +  'flexiblecouponforcart'
  return this.httpClient.get<any>(url);
}
getFirstTimeSignUpCouponForCart(): Observable<any> {
  const url: string = `${this.env.marketingServiceUrl}` +  'firsttimecouponforcart';
  return this.httpClient.get<any>(url);
}
checkCouponForFirstCustomer(id): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'checkcouponforfirstcustomer/' + id;
  return this.httpClient.get<any>(url);
}
checkCouponForPlaceOrder(id): Observable<any> {
  const url: string = `${this.env.marketingServiceUrl}` +  'checkcouponforplaceorder/' + id;
  return this.httpClient.get<any>(url);
}
checkCouponOnCustomer(coupon): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'checkcouponcodebycustomer';
  return this.httpClient.post<any>(url, coupon);
}
getCustomerDetails(userId): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` +  'getcustomerprofile/' + userId;
  return this.httpClient.get<any>(url);
}
getCustomerDetailsForPlaceorder(): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` +  'getcustomerdetailsforplaceorder' ;
  return this.httpClient.get<any>(url, {headers:{Authorization: this.commonService.getToken()}});
}
confirmCashOnDelivery(order) {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'cashondeliverycreation';
  return this.httpClient.post<any>(url, order);
}
confirmRazorPayOrder(order) {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'razorpayorder';
  return this.httpClient.put<any>(url, order);
}
addRazorpayResponse(data, id, total): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` +  'addrazorpay/' + id + '/total/' + total;
  return this.httpClient.put<any>(url, data);
}
reduseCustomerWallet(data, id): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` +  'reducecoininwallet/' + id;
  return this.httpClient.put<any>(url, data);
}

addCoinToWallet(data, id): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` +  'addcoininwallet/' + id;
  return this.httpClient.put<any>(url, data);
}
getMeasurementbyUser(): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` +  'getallmeasurementbyuser';
  return this.httpClient.get<Product>(url);
}
customerAddressDelete(userId, addressId): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` + 'deletecustomeraddress/' + userId + '/delete/' + addressId;
  return this.httpClient.delete<any>(url);
}
paypalOrderCreation(data): Observable<any> {
  const url: string =`${this.env.commerceOrderServiceUrl}` + 'paypalordercreation';
  return this.httpClient.post<any>(url, data);
}
getaddressDetails(addressHolder, userId): Observable<AddressModel> {
  const url: string = `${this.env.customerServiceUrl}` + 'updateaddressdetails/' + userId;
  return this.httpClient.put<AddressModel>(url, addressHolder);
}
customerAddressUpdate(userId, addressId, updateDetails): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` + 'editcustomeraddress/' + userId + '/update/' + addressId;
  return this.httpClient.put<any>(url, updateDetails);
}
checkPincodeForOrder(pincode): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` + 'checkpincodefororder/' + pincode;
  return this.httpClient.get<any>(url);
}
checkPincodeForCOD(pincode): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` + 'checkpincodeforcod/' + pincode;
  return this.httpClient.get<any>(url);
}
checkShiprocketPincodeForOrder(pincode): Observable<any> {
  const url: string = `${this.env.commonCallServiceUrl}` + 'checkshiprokcetpincodefororder/' + pincode;
  return this.httpClient.get<any>(url);
}
checkShiprocketPincodeForCOD(pincode): Observable<any> {
  const url: string = `${this.env.commonCallServiceUrl}` + 'checkshiprocketpincodeforcod/' + pincode;
  return this.httpClient.get<any>(url);
}
retrieveAllCODCondition(): Observable<any> {
  const url: string = `${this.env.commerceOrderServiceUrl}` + 'retrieveallcodconditionforui';
  return this.httpClient.get<any>(url);
}
checkEmailForCustomer(data): Observable<any> {
  const url: string = `${this.env.customerServiceUrl}` + 'checkemailforbuynow';
  return this.httpClient.post<any>(url, data);
}

getSearchSubProductCount(id, condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsearchsubcategoryproductcount/' + id;
  return this.httpClient.post<any>(url, condition);
}
getSearchMainProductCount(id, condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsearchmaincategoryproductcount/' + id;
  return this.httpClient.post<any>(url, condition);
}
getSearchSuperProductCount(id, condition): Observable<any> {
  const url: string = `${this.env.productServiceUrl}` + 'getsearchsupercategoryproductcount/' + id;
  return this.httpClient.post<any>(url, condition);
}
searchSuperCategoryProductWishFilter(id, condition) {
  const url: string = `${this.env.productServiceUrl}` + 'searchsupercategoryproductwishfilter/' + id;
  return this.httpClient.post<any>(url, condition).toPromise();
}
searchMainCategoryProductWishFilter(id, condition) {
  const url: string = `${this.env.productServiceUrl}` + 'searchmaincategoryproductwishfilter/' + id;
  return this.httpClient.post<any>(url, condition).toPromise();
}
searchSubCategoryProductWishFilter(id, condition) {
  const url: string = `${this.env.productServiceUrl}` + 'searchsubcategoryproductwishfilter/' + id;
  return this.httpClient.post<any>(url, condition).toPromise();
}
sendInquiryMail(emailInquiry): Observable<any> {
  const url = `${this.env.communicationServiceUrl}` + 'inquiryconfirmationmail';
  return this.httpClient.post<any>(url, emailInquiry);
}
getSizeGuideCategoryWithBrand(details): Observable<any> {
  const url = `${this.env.productServiceUrl}` + 'retrievesizeguidebycategorywithbrand';
  return this.httpClient.post<any>(url, details);
}
retrieveBrandProductFilter(details) {
  const url = `${this.env.productServiceUrl}` + 'retrievebrandproductfilter';
  return this.httpClient.post<any>(url, details).toPromise();
}
retrieveBrandProductFilterCount(details): Observable<any> {
  const url = `${this.env.productServiceUrl}` + 'retrievebrandproductcount';
  return this.httpClient.post<any>(url, details);
}
/* createRazorPayInstance(details): Observable<any> {
  const url = `${this.env.commerceOrderServiceUrl}` + 'createrazorpayinstance';
  return this.httpClient.put<any>(url, details);
} */

/* ------------- other module service call end ------------ */

// method

getPager(totalItems: number, currentPage: number = 1, pageSize: number = 30) {
  let totalPages = Math.ceil(totalItems / pageSize);

  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalPages) {
    currentPage = totalPages;
  }

  let startPage: number, endPage: number;
  if (totalPages <= 5) {
    startPage = 1;
    endPage = totalPages;
  } else {
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage + 2 >= totalPages) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 3;
      endPage = currentPage + 2;
    }
  }
  let startIndex = (currentPage - 1) * pageSize;
  let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
  let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
  return {
    totalItems: totalItems,
    currentPage: currentPage,
    pageSize: pageSize,
    totalPages: totalPages,
    startPage: startPage,
    endPage: endPage,
    startIndex: startIndex,
    endIndex: endIndex,
    pages: pages
  };
}
setCartWithTool(productId: string, INTsku: string, isTailoring: boolean, count: number,product: Child, bodyHeight: string, serviceId: string, isMeasurement?: boolean) {
  if (isTailoring) {
    return {
      productId: productId,
      INTsku: INTsku,
      qty: count,
      bodyHeight: bodyHeight,
      tailoringService: isTailoring,
      isMeasurement: isMeasurement,
      isUnstitched: !isMeasurement,
      serviceId: serviceId,
      product: product
    }
  } else {
    return {
      productId: productId,
      INTsku: INTsku,
      qty: count,
      bodyHeight: bodyHeight,
      tailoringService: isTailoring,
      product: product,
      serviceId: serviceId,
    }
  }
}
setCartWithOutTool(productId: string, INTsku: string, product: Child, count: Number) {
  return {
    productId: productId,
    INTsku: INTsku,
    qty: count,
    product: product
  }
}
setCartWithStringTool(productId: string, INTsku: string, product: Child, count: number, toolEnable: boolean, toolType?: string, tension?: string) {
  return {
    productId: productId,
    INTsku: INTsku,
    qty: count,
    product: product,
    toolEnable: toolEnable,
    toolType: toolType,
    tension: tension
  }
}
calculateSizeWiseIncrement(shopModel: Cart[], sizeIncrement) {
  for (const cart of shopModel) {
    if (cart.product.isPluzSize !== true && cart.product.variationType === 'Size') {
      for (const size of sizeIncrement) {
        if (size.subCategoryId && size.subCategoryId === cart.product.subCategoryId && Number(size.size) <= Number(cart.product.sizeVariant)) {
          cart.product.sizeIncApply = true;
          cart.product.sizeIncType = 'Additional charges for plus size';
          cart.product.sizeWisePrice = (cart.product.subPrice * size.incPercentage) / 100;
          cart.product.price = cart.product.price + cart.product.sizeWisePrice;
          cart.product.serviceDiscount = cart.product.discount;
          cart.product.serviceAmount = (cart.product.serviceAmount === undefined ? 0 : cart.product.serviceAmount) + cart.product.sizeWisePrice;
          cart.product.isPluzSize = true;
        } else if (size.superCategoryId && size.superCategoryId === cart.product.superCategoryId && Number(size.size) <= Number(cart.product.sizeVariant)) {
          cart.product.sizeIncApply = true;
          cart.product.sizeIncType = 'Additional charges for plus size';
          cart.product.sizeWisePrice = (cart.product.subPrice * size.incPercentage) / 100;
          cart.product.price = cart.product.price + cart.product.sizeWisePrice;
          cart.product.serviceDiscount = cart.product.discount;
          cart.product.serviceAmount = (cart.product.serviceAmount === undefined ? 0 : cart.product.serviceAmount) + cart.product.sizeWisePrice;
          cart.product.isPluzSize = true;
        }
      }
    }
  }
  return shopModel;
}
createCCAvenueOrder(cart): Observable<any> {
  const cartUrl = 'orderccavenue';
  const params = new HttpParams()
  .set('callbackUrl', this.env.commerceOrderServiceUrl)
  const url = this.env.commerceOrderServiceUrl + cartUrl;
  return this.httpClient.post(url, cart, {
    params: params
  });
}
orderCheckAfterPay(childIds): Observable<any> {
  const cartUrl = 'productchildfind';
  const params = new HttpParams()
  .set('childId', childIds.toString())
  const url = this.env.productServiceUrl + cartUrl;
  return this.httpClient.get(url, {
    params: params
  });
}
orderthroughccavenue(cart): Observable<Cart> {
  const cartUrl = 'orderthroughccavenue';
  const url: string = this.env.commerceOrderServiceUrl + cartUrl;
  return this.httpClient.post<Cart>(url, cart);
}
getFilterOption(): Observable<Cart> {
  const cartUrl = 'getfilteroptionsforui';
  const url: string = this.env.productServiceUrl + cartUrl;
  return this.httpClient.get<any>(url);
}
getCODSetting(): Observable<any> {
  const cartUrl = 'getallcodsetting';
  const url: string = this.env.commerceOrderServiceUrl + cartUrl;
  return this.httpClient.get<any>(url);
}
getPaymentSetting(): Observable<any> {
  const cartUrl = 'getpaymentsettingforwebsite';
  const url: string = this.env.commerceOrderServiceUrl + cartUrl;
  return this.httpClient.get<any>(url);
}
getDiscountFitler(): Observable<any> {
  const url: string = this.env.productServiceUrl + 'getdiscountfilter';
  return this.httpClient.get<any>(url);
}
checkCODPincodeValidation(data): any {
  const url: string = this.env.commerceOrderServiceUrl + 'checkpincodevalidationforcod';
  return this.httpClient.post<any>(url, data).toPromise();
}
checkFlexibleCouponForCouponApply(data): Observable<any> {
  const url: string = this.env.marketingServiceUrl + 'checkflexiblecouponforapply';
  return this.httpClient.post<any>(url, data);
}
checkProductForCoupon(data): Observable<any> {
  const url: string = this.env.productServiceUrl + 'checkproductforcoupon';
  return this.httpClient.post<any>(url, data);
}
getLocalCart(data): Observable<any> {
  const url: string = this.env.productServiceUrl + 'findlocalcart';
  return this.httpClient.post<any>(url, data);
}
checkCouponInExistingCustomer(data): Observable<any> {
  const url: string = this.env.commerceOrderServiceUrl + 'checkcouponinexistingcustomer';
  return this.httpClient.post<any>(url, data);
}
razorpayWithCODShipmentfess(data): Observable<any> {
  const url: string = this.env.commerceOrderServiceUrl + 'razorpaywithcodandshipmentfees';
  return this.httpClient.post<any>(url, data);
}
checkShippingFees(data): Observable<any> {
  const url: string = this.env.commerceOrderServiceUrl + 'checkshippingfees';
  return this.httpClient.post<any>(url, data);
}
checkWishlistForProduct(userId, productId): Observable<any> {
  const httpParams = new HttpParams().set('userId', userId).set('productId', productId);
  const url: string = this.env.productServiceUrl + 'checkproductforwishlist';
  return this.httpClient.get<any>(url, {params: httpParams});
}
getProductForWishlist(userId: string): Observable<any> {
  const url: string = this.env.productServiceUrl + 'getproductforwishlist/' + userId;
  return this.httpClient.get<any>(url);
}
getAttributeLabel(attributeId: string): Observable<any> {
  const url: string = this.env.productServiceUrl + 'getattributelabel/' + attributeId;
  return this.httpClient.get<any>(url);
}
}
